
(function ($) {
	
  $(document).ready(function(){
    
    var product_link = '/collections/all/products/';//$('.shop_url').text();
    var guideroot = $(".main-content .pant_guide");
    
    var selected_collection_id;
    var selected_product_handle;
    var selected_variant_url;
    var cookie_body_type;
    var cookie_style;
    var cookie_fit;
    var cookie_color;
    
    $.removeCookie("pant_type");
    $.removeCookie("pant_style");
    $.removeCookie("pant_fit");
    $.removeCookie("pant_color");
    $.removeCookie("page_redirect");
    
    guideroot.find(".step_start_content").addClass("active");
    guideroot.find(".step_start").addClass("active");
    guideroot.find(".step_start_second ul:first").addClass("selected_collection");
    guideroot.find(".step_start_third ul:first").addClass("selected_product");
    
    // guide title setting
    /*
    guideroot.find(".pant_guide_button").click(function(){
      
      	var guideactivetitle = guideroot.find(".pant_guide_title").find(".active");
      	var guideactivecontent = guideroot.find(".pant_guide_content").find(".active");
      	var guidenexttitle = guideactivetitle.next();
      	var guidenextcontent = guideactivecontent.parent().next().children();
      
      if (guidenexttitle.length){
        guidenexttitle.addClass("active");
        guideactivetitle.removeClass("active");
      	guidenextcontent.addClass("active");
        guideactivecontent.removeClass("active");
      } else {

      }

    });
    */
    
    $(".pant_guide_title .guide_title").click(function(){
      if(!($(this).hasClass("disabled"))){
        $(".pant_guide_title .guide_title").removeClass("active");
        $(this).addClass("active");
          var active_step = $(this).data("content");
          $(".pant_guide_content .guide_content").removeClass("active");
          $("." + active_step).addClass("active");
      }
    });
    
    // product filter
    $(".step_start_first li").click(function(){
      $(".step_start_first li").removeClass("selected_body_type");
      $(this).addClass("selected_body_type");
      selected_collection_id = $(this).find("p").data("collection_id");
      guideroot.find(".selected_collection").removeClass("selected_collection");
      var collection_find = ".collection-" + selected_collection_id;
      guideroot.find(".step_start_second").find(collection_find).addClass("selected_collection");
      
      guideroot.find(".guide_title.step_second").removeClass("disabled");  
      $(".pant_guide_title .guide_title").removeClass("active");
      $(".guide_title.step_second").addClass("active");
      $(".pant_guide_content .guide_content").removeClass("active");
      $(".guide_content.step_start_second").addClass("active");
               
      cookie_body_type = $(this).find("h2").data("collection_handle");
      $.cookie('pant_type', cookie_body_type);
	    var page_redirect = true;
      $.cookie('page_redirect', page_redirect);
    });
    
    $(".step_start_second li").click(function(){
      $(".step_start_second li").removeClass("selected_style");
      $(this).addClass("selected_style");
      selected_product_handle = $(this).find("p").data("product_id");
      guideroot.find(".selected_product").removeClass("selected_product");
      var product_find = ".product-" + selected_product_handle;
      guideroot.find(".step_start_third").find(product_find).addClass("selected_product");
      
      // guideroot.find(".guide_title.step_third").removeClass("disabled");
      // $(".pant_guide_title .guide_title").removeClass("active");
      // $(".guide_title.step_third").addClass("active");
      // $(".pant_guide_content .guide_content").removeClass("active");
      // $(".guide_content.step_start_third").addClass("active");

      var productTitle = $(this).find('.guide-product-title').text().replace(/\s/g,"-").toLowerCase();
      product_link = product_link + productTitle;
      
      cookie_style = $(this).data("product_style");
      cookie_fit = $(this).data("product_fit");
      $.cookie('pant_style', cookie_style);
      $.cookie('pant_fit', cookie_fit);
      $.cookie('page_redirect', 'true');

      if (selected_collection_id != null && selected_product_handle != null){
      	window.location.href = product_link;
      }
    });
    
    $(".step_start_third li").click(function(){
      $(".step_start_third li").removeClass("selected_wash");
      $(this).addClass("selected_wash");
      selected_variant_url = $(this).find("p").text();
      
      if (selected_collection_id != null && selected_product_handle != null && selected_variant_url != null){
      	product_link = product_link + selected_variant_url;
      	window.location.href = product_link;
      }
      
      //cookie_color = $(this).data("color_handle");
      //$.cookie('pant_color', cookie_color);
      //$.cookie('page_redirect', 'true');
    });
    
    //$(".pant_guide_button").click(function(){      	
      //if (selected_collection_id != null && selected_product_handle != null && selected_variant_url != null){
      	//product_link = product_link + selected_variant_url;
      	//window.location.href = product_link;
      //}
    //});
    

  
  });
  
  

}(jQuery));